import { render } from "./DigitalBooking.vue?vue&type=template&id=8876f286&scoped=true"
import script from "./DigitalBooking.vue?vue&type=script&lang=js"
export * from "./DigitalBooking.vue?vue&type=script&lang=js"

import "./DigitalBooking.vue?vue&type=style&index=0&id=8876f286&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8876f286"]])

export default __exports__